import { saveOrganization } from './organizationUtils';
export const saveToken = (token: string): void => {
  localStorage.setItem('token', token);
};

export const getToken = (): string | undefined => {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('token')) {
    const tokenFromSearchParams = `Bearer ${searchParams.get('token')}`;
    localStorage.setItem('token', tokenFromSearchParams);
    const pathSegments = window.location.pathname.split('/');
    const org = pathSegments[1];
    if (org) {
      saveOrganization(org);
    }

    // Don't clear URL parameters and redirect for specific pages that need the token in URL
    // const shouldNotRedirect = window.location.pathname.includes('/reset-password') ||
    //   window.location.pathname.includes('/apps/google') ||
    //   window.location.pathname.includes('/users') ||
    //      window.location.pathname.includes('/dashboard')

    // if (!shouldNotRedirect) {
    //   window.history.replaceState({}, '', window.location.pathname);
    //   window.location.href = handleCompanyUrl('/dashboard');
    // }
    return tokenFromSearchParams;
  }
  const tokenFromLocalStorage = localStorage.getItem('token');

  return (!!tokenFromLocalStorage as boolean) ? (tokenFromLocalStorage as string) : undefined;
};

export const removeToken = (): void => localStorage.removeItem('token');
